import PropTypes from 'prop-types';
import moment from 'moment';

import css from './index.module.scss';

const Countdown = ({ date }) => {
  const now = moment().startOf('day');
  const then = moment(date);
  if (then <= now) {
    return false;
  }
  return (
    <div className={css.root}>
      <h2 className={css.title}>Days Until the Event:</h2>
      <div className={css.days}>{then.diff(now, 'days')}</div>
      <p className={css.copy}>We can’t wait to start #DoingThings with you!</p>
    </div>
  );
};

Countdown.propTypes = {
  date: PropTypes.string.isRequired,
};

export default Countdown;
